import { useEffect, useState } from "react";
import { HttpCategory, HttpCategoryProduct } from "../http";
import type { Category } from "../types/Category";
import type { CategoryImage } from "../components/CategoryShowcase/ImageWithOverlay";

export function useCategoryShowcase(limit = 4) {
    const [images, setImages] = useState<CategoryImage[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        async function load() {
            try {
                const all: Category[] = await HttpCategory.getAllCategories();
                if (cancelled) return;

                const root = all
                    .filter((c) => c.idCategoriaPadre === null)
                    .sort((a, b) => (a.orden ?? 999999) - (b.orden ?? 999999))
                    .slice(0, limit);

                const resolved = await Promise.all(
                    root.map(async (cat) => {
                        let src = cat.urlImagen ?? "";
                        if (!src) {
                            try {
                                const res = await HttpCategoryProduct.getProductsByCategorySku(
                                    cat.sku,
                                    { pagina: 1, tamanoPagina: 1 }
                                );
                                const first = res?.paginaProductosDTO?.lista?.[0];
                                if (first?.urlImagenPrincipal) src = first.urlImagenPrincipal;
                            } catch {}
                        }
                        return {
                            src,
                            alt: cat.nombre,
                            title: cat.nombre,
                            link: `/categoria/${cat.sku}`,
                        };
                    })
                );

                if (!cancelled) setImages(resolved);
            } catch (err) {
                console.error("Error cargando categorías del showcase:", err);
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        load();
        return () => { cancelled = true; };
    }, [limit]);

    return { images, loading };
}
